import { ServiceLocation } from 'src/services/serviceLocationsAxios';
import {
  GetLabelQueryParams,
  GetRouteFinderQueryParams,
  GetRoutingByidQueryParams,
  LabelDto,
  LabelGenerationResultDto,
  LabelGeneratorModel,
  RoutingDto
} from 'src/models/routedetermination';
import {
  GetPlnBandingQueryParams,
  PlnBandingDto,
  PlnBandingListView,
  PlnBandingModel
} from 'src/views/uiflow/plnbanding/types';
import { GetAxiosInstance } from '../baseService';

// Get Labels
export const getLabels = async (params?: GetLabelQueryParams) => {
  return GetAxiosInstance().get<LabelDto[]>(ServiceLocation.routedetermination + '/label', { params });
};

// Get Routes
export const getRoutes = async (params?: GetRouteFinderQueryParams) => {
  return GetAxiosInstance().get<RoutingDto[]>(ServiceLocation.routedetermination + '/routefinder', { params });
};

// Get Route By Id
export const getRouteById = async (id: string, params?: GetRoutingByidQueryParams) => {
  return GetAxiosInstance().get<RoutingDto>(ServiceLocation.routedetermination + '/routing/' + id, { params });
};

// Post Label
export const postLabel = async (params: LabelGeneratorModel) => {
  return GetAxiosInstance().post<string>(ServiceLocation.routedetermination + '/labelgenerator', params);
};

// Post Label V2
export const postLabelV2 = async (ids: string[], labelId?: string) => {
  return GetAxiosInstance().post<{ data: LabelGenerationResultDto }>(
    ServiceLocation.routedetermination + '/labelgenerator/v2',
    ids,
    { params: labelId ? { labelId } : undefined }
  );
};

// PlnBanding CRUD operations
export const getPlnBandings = async (params?: GetPlnBandingQueryParams) => {
  return GetAxiosInstance().get<PlnBandingListView>(ServiceLocation.routedetermination + '/PlnBanding', { params });
};

export const getPlnBandingById = async (id: string, params?: { showDeleted?: boolean; ignoreOwner?: boolean }) => {
  return GetAxiosInstance().get<PlnBandingDto>(ServiceLocation.routedetermination + '/PlnBanding/' + id, { params });
};

export const postPlnBanding = async (model: PlnBandingModel) => {
  return GetAxiosInstance().post<PlnBandingDto>(ServiceLocation.routedetermination + '/PlnBanding', model);
};

export const putPlnBanding = async (id: string, model: PlnBandingModel) => {
  return GetAxiosInstance().put<PlnBandingDto>(ServiceLocation.routedetermination + '/PlnBanding/' + id, model);
};

export const deletePlnBanding = async (id: string, version: string) => {
  return GetAxiosInstance().delete<boolean>(ServiceLocation.routedetermination + '/PlnBanding/' + id, {
    data: { version }
  });
};

export const bulkDeletePlnBanding = async (models: Array<{ id: string; version: string }>) => {
  const bulkItems = models.map(item => ({
    id: item.id,
    model: { version: item.version }
  }));
  
  return GetAxiosInstance().delete<boolean>(ServiceLocation.routedetermination + '/PlnBanding', {
    data: bulkItems
  });
};

export const uploadPlnBandingCsv = async (file: File) => {
  const formData = new FormData();
  formData.append('FileContent', file);

  return GetAxiosInstance(
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    'multipart/form-data'
  ).post<boolean>(ServiceLocation.routedetermination + '/PlnBanding/upload', formData);
};